import React from 'react';

type TAlertProps = { message: string; onDismiss: () => void };

// eslint-disable-next-line react/prop-types
const Alert: React.FC<TAlertProps> = ({ message, onDismiss }) => {
    return (
        <div
            style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'absolute',
                top: '100px',
                zIndex: 9999,
            }}
        >
            <div
                style={{
                    backgroundColor: 'rgb(253, 236, 234)',
                    padding: '6px 16px',
                    display: 'flex',
                    color: 'rgb(97, 26, 21)',
                    borderRadius: 4,
                    boxShadow:
                        '0px 3px 1px -2px rgb(120 128 137 / 20%), 0px 2px 2px rgb(120 128 137 / 14%), 0px 1px 5px rgb(120 128 137 / 12%)',
                }}
            >
                <p dangerouslySetInnerHTML={{ __html: message }} />
                <button
                    style={{
                        background: 'none',
                        color: 'inherit',
                        border: 'none',
                        padding: 6,
                        font: 'inherit',
                        cursor: 'pointer',
                        outline: 'inherit',
                        fontSize: 16,
                        fontWeight: 'bold',
                        marginLeft: 24,
                    }}
                    onClick={onDismiss}
                >
                    X
                </button>
            </div>
        </div>
    );
};

export default Alert;
